import React from "react";
import moment from "moment";
import { TextFilter } from "../Filters/TextFilter";
import { getNews } from "../../../queries/news";
import cx from "classnames";

const RowStructure = (props) => {
    return (
        <tr key={props.id} className={cx("overview-redux__row", { "overview-redux__row--unread": !props.read })}>
            <td>{moment(props.publication_date).format("DD-MM-Y")}</td>
            <td>
                <a
                    className="nav-link"
                    href={`#${props.id}`}
                    onClick={(e) => {
                        e.preventDefault();
                        props.contextData.setActiveMessage(props);
                    }}
                >
                    {props.title}
                    {!props.read && <span className="news-pip" />}
                </a>
            </td>
        </tr>
    );
};

export const NewsOverviewDefinitionBase = {
    queryFn: getNews,
    RowStructure,
    columns: [
        {
            title: "Datum",
            columnIdentifier: "publication_date",
            className: "overview-redux__head--date",
            orderable: true
        },
        {
            title: "Nieuwsbericht",
            columnIdentifier: "title",
            orderable: true,
            Filter: TextFilter
        }
    ],
    defaults: {
        ordering: {
            columnIdentifier: "publication_date",
            direction: "-"
        },
        filter: {}
    }
};
